import { render, staticRenderFns } from "./ArchiveUpload.vue?vue&type=template&id=b70289b2&scoped=true&"
import script from "./ArchiveUpload.vue?vue&type=script&lang=js&"
export * from "./ArchiveUpload.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveUpload.vue?vue&type=style&index=0&id=b70289b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70289b2",
  null
  
)

export default component.exports